import { render, staticRenderFns } from "./PublicationLogsTable.vue?vue&type=template&id=0bcb269c&scoped=true"
import script from "./PublicationLogsTable.vue?vue&type=script&lang=js"
export * from "./PublicationLogsTable.vue?vue&type=script&lang=js"
import style0 from "./PublicationLogsTable.vue?vue&type=style&index=0&id=0bcb269c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcb269c",
  null
  
)

export default component.exports